<div class="searchConsole" >
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content rounded-0 border-0">
      <app-advance-header [breadcrumb]="breadCrumb" (valueChange)='getChildValue($event)'></app-advance-header>
      <div class="modal-body d-flex justify-content-center align-items-start" style="height: 100vh;">
        <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 text-white text-center h-100">
          <div class="tree-steper">
            <ul class="tree">
              <li class="check">
                <div class="sticky current">
                  <label class="prod-type">{{
                    searchDataList?.l2_actual_name
                    }}</label>
                  <span class="prod-img">
                    <img src="{{ searchDataList?.l2_image_path }}" class="img-fluid" alt="" />
                  </span>
                </div>
                <ul>
                  <li class="check" *ngFor="let value of level2Data;let id = index"
                    [ngClass]="{'level3-active ': selectedLevel2ID === id, 'level2-active': id==0, 'level3-active': selectedLevel2ID < id==0}">
                    <div class="sticky " [ngClass]="{'current': selectedLevel2ID === id}"
                      (click)="onclickLevel2(id,'level2');onsearchlevel3(breadCrumb.l1_actual_name ,breadCrumb.l2_actual_name);serach2click(value);">
                      <label class="prod-type">{{
                        value?.l3_display_name
                        }}</label>
                      <span class="prod-img">
                        <img src="{{ value?.l3_image_path }}" class="img-fluid" alt="" />
                      </span>
                    </div>
                    <ul *ngIf="selectedLevel2ID === id">
                      <li *ngFor="let data of level3data;let id = index">
                        <div class="sticky level3" [ngClass]="{'current': selectedLevel3ID === id}" [ngClass]="{'level3': isMobile && level3data?.length==1}"
                          (click)="onclickLevel2(id,'level3')">
                          <!-- <label class="prod-type">{{data.ppl_actual_name}}</label> -->
                          <label class="prod-type level3Font">{{data.ppl_display_name}}</label>
                          <span class="prod-img" (click)="level4Click(data)">
                            <img data-bs-target="#searchConsoleDefult4" [src]="level2newImages?.l3_actual_name == 'Maxi Van passenger' || level2newImages?.l3_actual_name == 'Maxi Van-Ambulance' || level2newImages?.l3_actual_name == 'Mini Van' ||  level2newImages?.l3_actual_name == 'ICV Buses school' || level2newImages?.l3_actual_name == 'LCV Buses school' ? level2newImages?.l3_image_path: data.ppl_image_path"
                              class="img-fluid" alt="image path" />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div *ngIf="setTrue">
    <app-advance-smart-select [ProductListingData]="productDetailsData" [level3Image]="level3DataImages" [productPriceForEMi]="productPrice" [level3Datas]="level3data" [breadCrumbData]="breadCrumb"></app-advance-smart-select>
</div> -->
